import { ProductModelEditor } from "./product-model-editor/product-model-editor";
import { ModelPreview } from "./model-preview/model-preview";
import { DesignAreasEditor } from "./design-areas-editor/design-areas-editor";
import { PreviewTemplatesEditor } from "./preview-templates-editor/preview-templates-editor";
import { CustomProductEditor } from "./custom-product-editor/custom-product-editor";

declare global {
  interface Window {
    ProductDesigner: {
      ModelPreview: typeof ModelPreview;
      ProductModelEditor: typeof ProductModelEditor;
      DesignAreasEditor: typeof DesignAreasEditor;
      PreviewTemplatesEditor: typeof PreviewTemplatesEditor;
      CustomProductEditor: typeof CustomProductEditor;
    };
  }
}

window.ProductDesigner = {
  ModelPreview,
  ProductModelEditor,
  DesignAreasEditor,
  PreviewTemplatesEditor,
  CustomProductEditor,
};
